<template>
  <div class="table_actions">
    <call-tooltip
      v-if="!isClosed"
      placement="top"
      content="Edit">
      <call-button
        outlet
        type="warning"
        round
        not-border
        :icon="dataReadingIcon"
        @click="clickAction('update')" />
    </call-tooltip>
    <template v-if="isAdmin">
      <call-tooltip
        v-if="!isClosed"
        placement="top"
        content="Deactivate">
        <call-button
          outlet
          type="danger"
          round
          not-border
          :icon="dataLockIcon"
          @click="clickAction('deactivate')" />
      </call-tooltip>
      <call-tooltip
        v-else-if="false"
        placement="top"
        content="Reactivate">
        <call-button
          outlet
          type="danger"
          round
          not-border
          :icon="dataUnlockIcon"
          @click="clickAction('activate')" />
      </call-tooltip>
    </template>
  </div>
</template>

<script>
import CallButton from '../common/CallButton';
import {
  faPen,
  faPowerOff,
  faBackward
} from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CallTableIssuesActions',
  components: { CallButton },
  props: {
    isClosed: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataReadingIcon: faPen,
      dataLockIcon: faPowerOff,
      dataUnlockIcon: faBackward
    };
  },
  methods: {
    clickAction (action) {
      this.$emit('on-action', action);
    }
  }
};
</script>
